import { AppLanguage } from '@/features/i18n/AppLanguage';

export const defaultAppLanguage = AppLanguage.German;
